/**
 * Stores a single item in-memory only in case we decided session / local storage is not appropriate.
 */
export class InMemoryStorage implements Storage {
  id: string;
  item: string | null = null;
  length = 0;

  constructor(key: string) {
    this.id = key;
  }
  getItem(key: string): string | null {
    return this.item;
  }
  key(index: number): string | null {
    return this.id;
  }
  removeItem(key: string): void {
    this.clear();
  }
  setItem(key: string, value: string): void {
    this.item = value;
    this.length = 1;
  }
  clear(): void {
    this.item = null;
    this.length = 0;
  }
}
